import { render, staticRenderFns } from "./LECO_SsoRedirect.vue?vue&type=template&id=571ede26&scoped=true&"
import script from "./LECO_SsoRedirect.vue?vue&type=script&lang=js&"
export * from "./LECO_SsoRedirect.vue?vue&type=script&lang=js&"
import style0 from "./LECO_SsoRedirect.vue?vue&type=style&index=0&id=571ede26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571ede26",
  null
  
)

export default component.exports